import template from './manage-late-entry-reasons.html';
import controller from './manage-late-entry-reasons.controller';

let ManageLateEntryReasonsModal = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'md',
  windowClass: 'hmodal-info animated fadeIn'
};

export default ManageLateEntryReasonsModal;




// WEBPACK FOOTER //
// ./client/pages/profile/modals/manage-late-entry-reasons/manage-late-entry-reasons.component.js